module.exports = __webpack_public_path__ + "img/lr-cb66-r1.74663cbf.gif";